import { FC } from 'react';
import {
  GraduationCap,
  GamepadIcon,
  Trophy,
  Users,
  BookOpen,
  UserPlus,
  Sparkles
} from 'lucide-react';

const features = [
  {
    icon: GraduationCap,
    title: "Educación Financiera Práctica",
    description: "Prepare a su hijo para el éxito financiero con lecciones prácticas y relevantes. Desarrollará habilidades esenciales que la escuela tradicional no enseña.",
    color: "bg-[#F59E0B]",
    textColor: "text-[#F59E0B]"
  },
  {
    icon: GamepadIcon,
    title: "Aprendizaje Divertido y Efectivo",
    description: "Su hijo aprenderá mientras se divierte con juegos educativos diseñados por expertos. La diversión es la clave para mantener su interés y asegurar un aprendizaje duradero.",
    color: "bg-[#8B5CF6]",
    textColor: "text-[#8B5CF6]"
  },
  {
    icon: Trophy,
    title: "Sistema de Motivación Inteligente",
    description: "Observe cómo su hijo desarrolla disciplina y perseverancia. Nuestro sistema de logros y recompensas mantiene a su hijo motivado y comprometido con su educación financiera.",
    color: "bg-[#EF4444]",
    textColor: "text-[#EF4444]"
  },
  {
    icon: Users,
    title: "Ambiente Seguro y Controlado",
    description: "Tenga la tranquilidad de que su hijo aprende en un entorno digital seguro y supervisado, diseñado específicamente para su desarrollo y protección.",
    color: "bg-[#6366F1]",
    textColor: "text-[#6366F1]"
  },
  {
    icon: BookOpen,
    title: "Recursos Educativos Completos",
    description: "Acceda a una biblioteca completa de recursos que le ayudarán a guiar el aprendizaje de su hijo. Materiales diseñados para complementar y reforzar la educación financiera.",
    color: "bg-[#F97316]",
    textColor: "text-[#F97316]"
  },
  {
    icon: UserPlus,
    title: "Seguimiento del Progreso",
    description: "Monitoree el avance de su hijo en tiempo real. Vea cómo desarrolla habilidades financieras esenciales y celebre juntos cada logro alcanzado.",
    color: "bg-[#10B981]",
    textColor: "text-[#10B981]"
  }
];

export const PlatformFeatures: FC = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary mb-6">
            <Sparkles className="h-4 w-4" />
            <span className="text-sm font-medium">Inversión en el futuro de sus hijos</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
            La mejor plataforma para la educación financiera de sus hijos
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Brinde a sus hijos las herramientas que necesitan para construir un futuro financiero sólido
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative p-6 bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-gray-200"
            >
              <div className={`h-14 w-14 rounded-xl ${feature.color}/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <feature.icon className={`h-7 w-7 ${feature.textColor}`} />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
              <div className={`absolute inset-x-0 bottom-0 h-1 ${feature.color} rounded-b-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
